var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokerage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38046 30.1085L7.02728 30.6872L7.80728 28.4673L2.3116 26.5361L0.70752 32.4615L2.97874 33.0764L3.42728 31.4195C7.30281 37.8832 14.6798 40.9829 21.6762 39.7212L21.2587 37.4056C14.867 38.5581 8.57489 35.5538 5.38046 30.1085Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9524 9.89091L34.3057 9.31225L33.5257 11.5322L39.0214 13.4633L40.6254 7.53789L38.3542 6.92315L37.9057 8.58001C34.0578 2.16229 26.7058 -0.993088 19.6567 0.278442L20.0743 2.59397C26.4656 1.44158 32.7579 4.4455 35.9524 9.89091Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.078 27.1231C28.1319 27.1231 26.5486 25.5398 26.5486 23.5937C26.5486 22.06 27.5322 20.7523 28.9015 20.2667V15.4238C23.6075 16.0092 19.4897 20.4966 19.4897 25.9467C19.4897 31.3966 23.6075 35.8841 28.9015 36.4695V31.829H26.5486V29.4761H30.078C30.7268 29.4761 31.2545 28.9482 31.2545 28.2996C31.2545 27.6508 30.7268 27.1231 30.078 27.1231Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4312 27.0587C14.1052 27.0587 15.697 26.7084 17.1387 26.0782C17.0868 21.172 19.8148 16.6713 24.1645 14.4349C23.7245 8.33855 18.6398 3.5293 12.4312 3.5293C5.93372 3.5293 0.666504 8.79651 0.666504 15.294C0.666504 21.7915 5.93372 27.0587 12.4312 27.0587ZM9.38909 9.7562L12.0867 12.4538L14.7842 9.7562L16.4479 11.42L13.2631 14.6047V16.4704H15.616V18.8233H13.2631V21.1763H10.9101V18.8233H8.55717V16.4704H10.9101V14.6047L7.72533 11.42L9.38909 9.7562Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2548 15.4238V20.0643H33.6077V22.4172H30.0783C29.4296 22.4172 28.9019 22.9449 28.9019 23.5937C28.9019 24.2423 29.4296 24.7702 30.0783 24.7702C32.0245 24.7702 33.6077 26.3534 33.6077 28.2996C33.6077 29.8333 32.6241 31.1409 31.2548 31.6267V36.4695C36.5488 35.8841 40.6666 31.3966 40.6666 25.9467C40.6666 20.4966 36.5488 16.0092 31.2548 15.4238Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerage);
export default __webpack_public_path__ + "static/media/Brokerage.7a2491cc8cb30b8cc3fcdc0745c46497.svg";
export { ForwardRef as ReactComponent };